// Source - https://stackoverflow.com/a
// Posted by Why u do dis
// Retrieved 2025-12-29, License - CC BY-SA 4.0

var sticky = document.querySelector(".site-nav.site-navigation");
var stickyAnchor = sticky.parentNode;
var state = false;

function getAnchorOffset() {
  return stickyAnchor.getBoundingClientRect().top;
}

updateSticky = function (e) {
  if (!state && getAnchorOffset() < 0) {
    sticky.classList.add("is-sticky");
    state = true;
  } else if (state && getAnchorOffset() >= 0) {
    sticky.classList.remove("is-sticky");
    state = false;
  }
};

window.addEventListener("scroll", updateSticky);
window.addEventListener("resize", updateSticky);

// function to check if there is any announcement bar
function handleAnnouncementBar() {
  var announcementBar = document.querySelector(".announcement-bar");
  if (announcementBar) {
    const annnouncementBarParent = announcementBar.parentNode;
    annnouncementBarParent.classList.add("is-sticky");
    sticky.classList.add("has-announcement-bar");
  }
}

// Initial check in case the page is loaded scrolled down
document.addEventListener("DOMContentLoaded", function () {
  updateSticky();
  handleAnnouncementBar();
});
